import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { CalendlyService } from 'src/app/services/calendly.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-header',
    imports: [CommonModule, RouterModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  private readonly destroy$ = new Subject<void>();
  public calendlyUrl = environment.CALENDLY_URL;
  isMobile = false;
  isMobileMenuOpen = false;
  isScrolled = false;
  currentRoute = '/';

  @HostListener('window:resize')
  onResize() {
    this.checkScreenWidth();
  }

  @HostListener('window:scroll')
  onScroll() {
    if (typeof window === 'undefined') {
      return;
    }
    this.isScrolled = window.scrollY > 20;
  }

  constructor(
    private router: Router,
    private calendly: CalendlyService
  ) {
    this.currentRoute = this.router.url;
  }

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      this.checkScreenWidth();
      this.onScroll();
    }

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(event => {
        this.currentRoute = event.urlAfterRedirects;
        this.isMobileMenuOpen = false;
        this.scrollToTop();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkScreenWidth(): void {
    if (typeof window === 'undefined') {
      return;
    }

    if (window.innerWidth <= 1250) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
      this.isMobileMenuOpen = false;
    }
  }

  toggleMobileMenu(): void {
    if (!this.isMobile) {
      return;
    }
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  navigateTo(route: string): void {
    this.isMobileMenuOpen = false;
    if (route === this.currentRoute) {
      this.scrollToTop();
      return;
    }
    this.router.navigate([route]);
  }

  onNavigationLinkClick(route: string): void {
    this.isMobileMenuOpen = false;
    if (route === this.currentRoute) {
      this.scrollToTop();
    }
  }

  isActive(route: string): boolean {
    if (route === '/') {
      return this.currentRoute === '/';
    }
    return this.currentRoute.startsWith(route);
  }

  openCalendlyPopup() {
    return this.calendly.openPopup(this.calendlyUrl);
  }

  private scrollToTop(): void {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }

}
